import { v2PrepaymentByPrepaymentId, prepaymentOutsourceGetDetail } from 'services/api';
import { create } from 'zustand';
import globalLoading from '@mpc/common/src/components/globalLoading';
import { $sType } from '@mpc/common';

type PrepaymentDetail = {
  detail: any;
  loadDetail: (id?: number) => void;
  closeDetail: () => void;
};

const usePrepayment = create<PrepaymentDetail>((set, get) => {
  return {
    detail: {},
    loadDetail: async (id) => {
      let fetchApi = $sType === 'inner' ? v2PrepaymentByPrepaymentId : prepaymentOutsourceGetDetail;
      try {
        globalLoading.show();
        const res = await fetchApi({
          prepayment_id: id || get()?.detail?.base_info?.id,
        });
        set({ detail: res?.data || {} });
      } catch (error) {
        console.log(error);
      } finally {
        globalLoading.done();
      }
    },
    closeDetail: () => set({ detail: {} }),
  };
});

export default usePrepayment;
